var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AREA_LOCK",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #AREA_LOCK .cls-1 {\n        opacity: 0.75;\n      }\n\n      #AREA_LOCK .cls-2, .cls-5 {\n        fill: none;\n      }\n\n      #AREA_LOCK .cls-2 {\n        stroke: #3e4346;\n      }\n\n      #AREA_LOCK .cls-3 {\n        fill: #3e4346;\n      }\n\n      #AREA_LOCK .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.62,17.9H0v-9H11.62Zm-4.171-5.84A1.666,1.666,0,0,0,5.78,10.39a1.615,1.615,0,0,0-1.609,1.669,1.676,1.676,0,0,0,.775,1.43l-.417,2.5H7.091l-.417-2.5A1.828,1.828,0,0,0,7.449,12.058Z",
    transform: "translate(0 -3.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.69,3.873a2.384,2.384,0,1,1,4.767,0V5.9h1.49V3.873a3.873,3.873,0,1,0-7.747,0V5.9H4.69Z",
    transform: "translate(-1.293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLock);
export default __webpack_public_path__ + "static/media/shape-lock.e42151f507216c71278e7c33ce38ed20.svg";
export { ForwardRef as ReactComponent };